
import * as Sentry from '@sentry/vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import TeamMember from '@/interfaces/team_member'

@Component
export default class KickFromTeam extends Vue {
  @Prop()
  details!: TeamMember

  @Prop()
  teamId!: number

  get url(): string {
    return `${process.env.VUE_APP_URL}/backend/api/team/${this.teamId}/member/${this.details.id}/`
  }

  async kickFromTeam(): Promise<void> {
    try {
      const response = await fetch(this.url, {
        method: 'DELETE',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRFToken': Vue.$cookies.get('csrftoken'),
        },
      })

      if (response.ok) {
        // Attempt to parse the json, get the id, and then redirect
        this.$store.dispatch('fetchTeams')
        this.$emit('close')
        this.$notify({ text: `Successfully kicked ${this.details.character.name} @ ${this.details.character.world} from the Team!`, type: 'is-success' })
      }
      else {
        this.$notify({ text: `Unexpected response ${response.status} when attempting to kick Team Member.`, type: 'is-danger' })
      }
    }
    catch (e) {
      this.$notify({ text: `Error ${e} when attempting to kick Team Member.`, type: 'is-danger' })
      Sentry.captureException(e)
    }
  }
}
